/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Countryrequired1Inputs */

const en_countryrequired1 = /** @type {(inputs: Countryrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country is required`)
};

const de_countryrequired1 = /** @type {(inputs: Countryrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Country is required" |
*
* @param {Countryrequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const countryrequired1 = /** @type {((inputs?: Countryrequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Countryrequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_countryrequired1(inputs)
	return de_countryrequired1(inputs)
});
export { countryrequired1 as "countryRequired" }